import Image from 'next/image';
import { useRouter } from 'next/router';

import { useGetEnrolledDiscountCodes } from '@/hooks/react-query/common/discount-policy';

import * as S from './style';

/**
 * 모바일 Gnb 사이드바 열었을 때, 데스크탑 Gnb 사람 아이콘 오프했을때 나타나는 배너
 * @param onlineUserId
 * @constructor
 */

interface Props {
  onlineUserId: string;
}
export function DiscountCodeBanner({ onlineUserId }: Props) {
  const { data, isLoading } = useGetEnrolledDiscountCodes(onlineUserId);
  const router = useRouter();

  if (isLoading || !data || !data.code) {
    return null;
  }

  return (
    <S.Banner onClick={() => router.push('/users/my-page?tab=나의 수강')}>
      <Image
        src='/images/discount/bill.webp'
        width={20}
        height={20}
        unoptimized
        alt='달러표시 아이콘'
      />
      <div>
        항플 <span>소개</span>하고, 최대 <span>100만 원</span> 받으러 가기
      </div>
    </S.Banner>
  );
}
